import { makeStyles, Theme } from '@material-ui/core';

export const useTransactionInfoStyle = makeStyles<Theme>((theme) => ({
  captionSxMb: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    color: '#ABABAB',
    marginBottom: '4px',
  },
  titleSxMb: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    color: '#FFFFFF',
  },
  memoSxMb: {
    marginBottom: '16px',
  },
  titleSx: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    color: '#FFFFFF',
  },
  tagsSx: {
    mt: '4px',
    display: 'flex',
    columnGap: theme.spacing(1),
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  tagSx: {
    padding: '4px',
    background: '#3C3C44',
    alignItems: 'baseline',
    fontWeight: 400,
    fontsize: 12,
    fontSize: '90%',
    color: '#FAFAFA',
    lineHeight: '12px',
    borderRadius: '6px',
  },
  dflexWrapSx: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  iconSx: {
    marginLeft: '4px',
  },
}));
